import type {CommentDto} from '@domain/comments'
import {getCommentLastModified} from '@domain/comments'
import {dataTestId} from '@hconnect/uikit'
import {formatTimeZoneDate} from '@hconnect/uikit/src/common'
import {NotificationBadge} from '@hconnect/uikit/src/lib2/components/comment'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {Box, Typography, Tooltip, TooltipProps} from '@mui/material'
import Markdown from 'markdown-to-jsx'
import {CSSProperties, FC} from 'react'
import {useTranslation} from 'react-i18next'

interface CommentNotificationProps {
  comment: CommentDto
  styles?: {notification?: CSSProperties; tooltip?: CSSProperties}
  tooltipPlacement?: TooltipProps['placement']
}

export const CommentNotificationWithTooltip: FC<CommentNotificationProps> = ({
  comment,
  styles,
  tooltipPlacement = 'top-end'
}) => {
  const timezoneId = useUpmPlantTimezone()
  const {
    i18n: {language}
  } = useTranslation()

  return (
    <Box sx={{pointerEvents: 'auto'}}>
      <Tooltip
        placement={tooltipPlacement}
        // for mobile devices
        enterTouchDelay={0}
        sx={{
          '& .MuiTooltip-tooltip': {
            maxWidth: (theme) => theme.spacing(80)
          }
        }}
        style={styles?.tooltip}
        title={
          <Box {...dataTestId('comment_notification_tooltip_content')}>
            <Markdown>{comment.value}</Markdown>
            <Box pt={1.5}>
              <Typography variant="body1">
                {`${getCommentLastModified(comment).user}, ${formatTimeZoneDate(
                  getCommentLastModified(comment).date,
                  timezoneId,
                  'DD MMM LT',
                  language
                )}`}
              </Typography>
            </Box>
          </Box>
        }
      >
        <NotificationBadge
          value={1}
          testId="comment_notification"
          styles={{notification: styles?.notification}}
        />
      </Tooltip>
    </Box>
  )
}
